import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useSnackbar } from 'notistack';
import { removeSnackbar } from '../../actions/Status';
import { bindActionCreators, Dispatch } from 'redux';
import { ReduxState } from 'reducers/types';
import { connectWithRouter } from 'helpers/connectWithRouter';

interface NotifierProps {
  notifications: Array<{ id: string; message: string; options?: object }>;
  removeSnackbar: (id: string) => void;
}

const Notifier: React.FC<NotifierProps> = ({ notifications, removeSnackbar }) => {
  const { enqueueSnackbar } = useSnackbar();
  const displayed = useRef<string[]>([]);

  const storeDisplayed = (id: string) => {
    displayed.current = [...displayed.current, id];
  };

  useEffect(() => {
    notifications.forEach((notification) => {
      if (displayed.current.includes(notification.id)) return;

      enqueueSnackbar(notification.message, notification.options);
      storeDisplayed(notification.id);
      removeSnackbar(notification.id);
    });
  }, [notifications, enqueueSnackbar, removeSnackbar]);

  return null;
};

// Wire up redux state to component
function mapStateToProps(state: ReduxState) {
  return {
    notifications: state.notifications.notifications,
  };
}

// Wire up redux dispatch functions
function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      removeSnackbar,
    },
    dispatch,
  );
}

// Connect it to Redux
export default connect(mapStateToProps, mapDispatchToProps)(Notifier);
